import {
    PurchasedDataSourceConnectionWithOrganization,
    useCreatePurchasedDatasetFromApiKeyMutation,
} from "@biggeo/bg-server-lib/studio";
import { Formik } from "formik";
import { useState } from "react";
import Zod from "zod";
import { toFormikValidationSchema } from "zod-formik-adapter";

import { useCloseModal } from "../../common/redux/hooks";
import { useErrorToast } from "../../toaster/containers/redux/hooks";
import EnterAccessKeyForm from "../components/EnterAccessKeyForm";
import SuccessfulAccessKey from "../components/SuccessfulAccessKey";

type CheckAccessKey = {
    apiKey: string;
};

const initialValues = {
    apiKey: "",
};

const EnterAccessKeyContainer = ({
    reload,
    setReload,
}: { reload: boolean; setReload: (v: boolean) => void }) => {
    const errorToast = useErrorToast();
    const closeModal = useCloseModal();

    const [response, setResponse] =
        useState<PurchasedDataSourceConnectionWithOrganization>();

    const {
        executeMutation: createPurchasedDataset,
        mutationReturn: [_, { loading }],
    } = useCreatePurchasedDatasetFromApiKeyMutation();

    const handleUnlock = (apiKey: string) => {
        createPurchasedDataset({
            variables: { apiKey },
            onCompleted: (d) => {
                setResponse(d.createPurchasedDatasetFromApiKey);
                setReload(!reload);
            },
            onError: () => {
                errorToast("Invalid Access Key!");
            },
        });
    };

    return (
        <Formik<CheckAccessKey>
            initialValues={initialValues}
            validateOnMount
            onSubmit={(values, _actions) => {
                handleUnlock(values.apiKey);
            }}
            validationSchema={toFormikValidationSchema(
                Zod.object({
                    apiKey: Zod.string().regex(
                        /^(?:[A-Z0-9]{4}-){7}[A-Z0-9]{4}$/i
                    ),
                })
            )}
        >
            {({ values, setFieldValue, handleSubmit }) => {
                return response ? (
                    <SuccessfulAccessKey
                        response={response}
                        onClickDone={() => closeModal()}
                    />
                ) : (
                    <EnterAccessKeyForm
                        apiKey={values.apiKey}
                        onChangeAccessKey={(v) => {
                            setFieldValue("apiKey", v);
                        }}
                        onUnlock={handleSubmit}
                        loading={loading}
                    />
                );
            }}
        </Formik>
    );
};
export default EnterAccessKeyContainer;
